import Mutations from '../../odata/mutations';

export default { ...new Mutations('reportDefinition'), ...new Mutations('reportDefinitions') };
